import { useEffect, useRef } from 'react'

/**
 * Sometimes data is scoped to a GQL query. Its value is briefly `undefined` when query parameters change. So
 * propagating the previous value while the new is still loading prevents UX shifts down the tree due to `undefined`
 * value being propagated for a render cycle.
 */
const useLatestDefined = <T extends any>(data: T): T => {
  const prevData = useRef(data)

  useEffect(() => {
    if (data !== undefined) {
      prevData.current = data
    }
  }, [data])

  return data === undefined ? prevData.current : data
}

export default useLatestDefined
